import { introModule } from './intro';
import { mintModule } from './mint/core';
import { mintItModule } from './mint/it';
import { mintTravelModule } from './mint/travel';
import { mintBusinessModule } from './mint/business';
import { ecosystemModule } from './ecosystem';
import { researchSpaceModule } from './research-space';
import { nativeModule } from './native';
import { carbonmoveModule } from './carbonmove';
import { climateViewPointModule } from './climateviewpoint';
import { etrustModule } from './etrust';
import { sharedCapabilitiesModule } from './shared-capabilities';
import { technologyModule } from './technology';
import { processModule } from './process';
import { futureModule } from './future';
import { closingModule } from './closing';
import type { PresentationModule } from '../presentation/types';

/** Every module that exists. Whether it appears is decided by presentation/config.ts. */
export const MODULES: readonly PresentationModule[] = [
  introModule,
  mintModule,
  mintItModule,
  mintTravelModule,
  mintBusinessModule,
  ecosystemModule,
  researchSpaceModule,
  nativeModule,
  carbonmoveModule,
  climateViewPointModule,
  etrustModule,
  sharedCapabilitiesModule,
  technologyModule,
  processModule,
  futureModule,
  closingModule,
];
